var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.711 3.546-6.753 6.757a.65.65 0 0 1-.924 0L.308 6.58a.614.614 0 0 1 0-.869l.954-.955c.24-.24.629-.24.869 0L4.03 6.655a.652.652 0 0 0 .923 0l4.934-4.934a.655.655 0 0 1 .924 0l.9.901a.654.654 0 0 1 0 .924"
  })));
};

export default SvgCheckmark;